
import React from 'react';
import OrphangeVisit2023 from 'views/OrphangeVisit2023'

const SecondarySchoolpage = () => {
  return <OrphangeVisit2023/>;
};

export default SecondarySchoolpage;